// @flow

export const actionTypes = {
  FETCH_TOKEN_FROM_STORAGE: 'Authenticate/FETCH_TOKEN_FROM_STORAGE',

  LOGIN: 'Authenticate/LOGIN',
  LOGIN_REQUEST: 'Authenticate/LOGIN_REQUEST',
  LOGIN_SUCCESS: 'Authenticate/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'Authenticate/LOGIN_FAILURE',

  LOGIN_MATRIX_SUCCESS: 'Authenticate/LOGIN_MATRIX_SUCCESS',

  VERIFY_LOGIN: 'Authenticate/VERIFY_LOGIN',
  VERIFY_LOGIN_REQUEST: 'Authenticate/VERIFY_LOGIN_REQUEST',
  VERIFY_LOGIN_SUCCESS: 'Authenticate/VERIFY_LOGIN_SUCCESS',
  VERIFY_LOGIN_FAILURE: 'Authenticate/VERIFY_LOGIN_FAILURE',

  BIND_DEVICE: 'Authenticate/BIND_DEVICE',
  BIND_DEVICE_REQUEST: 'Authenticate/BIND_DEVICE_REQUEST',
  BIND_DEVICE_SUCCESS: 'Authenticate/BIND_DEVICE_SUCCESS',
  BIND_DEVICE_FAILURE: 'Authenticate/BIND_DEVICE_FAILURE',

  LOGOUT: 'Authenticate/LOGOUT'
}
